module.exports = __webpack_public_path__ + "img/icon_carOut.05a8a975.png";